<template>
  <div class="price_wrapper">
     <div class="title">大宗材料价格行情</div>
     <p class="nowtime">{{nowTime}}</p>
     <div class="item_content ">
        <vue-seamless-scroll :data="barData" class="warp" :class-option="defaultOption">
            <div class="item flex" v-for="(item,index) in barData" :key="index">
                <p class="name">{{item.productName}}</p>
                <p>
                    <span v-if="item.changeRange>0" style="color:#EA7266">{{item.price}}{{item.unit}}</span>
                    <span v-if="item.changeRange<0" style="color: #50AA43">{{item.price}}{{item.unit}}</span>
                    <span v-if="item.changeRange==0" style="color:#666666">{{item.price}}{{item.unit}}</span>
                </p>
            </div>
        </vue-seamless-scroll>
    </div>
    <div class="more" >查看更多<i class="el-icon-arrow-right"></i></div>
  </div>
</template>

<script>
import cmsApi from  '../../api/cms/index.js';
import {dateformate} from '../../utils/utils'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
    components: {
        vueSeamlessScroll
    },
    data(){
        return {
 
            barData:[],
            nowTime:dateformate(new Date(), 'yyyy年MM月dd日')
        }
    },
    computed: {
        defaultOption() {
        return {
            step: 0.5, // 数值越大速度滚动越快
            limitMoveNum: this.barData.length, // 开始无缝滚动的数据量 this.dataList.length
            hoverStop: true, // 是否开启鼠标悬停stop
            direction: 1, // 0向下 1向上 2向左 3向右
            openWatch: true, // 开启数据实时监控刷新dom
            singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
            singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
            waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        };
        },
    },

    created(){
        this.getNewPriceByProduct()
    },
    methods:{
        async getNewPriceByProduct() { 
            let params={
                pageNo:1,
                pageSize:100
            }
            await cmsApi.getNewPriceByProduct(params).then(res => {
                if(res.success){
                    this.barData=res.data.records;
                }
            })
        },
        openUrl(url, type) {
            window.open(url, type)
        },
    }
}
</script>

<style lang="scss" scoped>
.price_wrapper{
    height: 100%;
    background: #F4F7FF;
    padding-top: 10px;
    .title{
        color: #000000;
        font-size: 16px;
        text-align: center;
        position: relative;
    }
    .title::after{
        content: ' ';
        width: 42px;
        height:2px;
        background: #2587FF;
        position: absolute;
        bottom: 0px;
        left: 70px;
    }
    .nowtime{
        font-size: 14px;
        color: #666666;
        text-align: center;
    }
    .item_content {
        padding:10px;
    }
    .warp{
        height:256px;
        
        overflow: hidden;
        // margin:10px;
        .item{
            line-height: 32px;
            justify-content: space-between;
        }
    }
    .more{
        text-align: center;
        color: #2587FF;
        font-size: 14px;
        cursor: pointer;
    }
}

</style>